// 判断当前url走什么埋点
export const getUrlGtm = (
    url: string,
    locale: string,
    {
        product_name = '',
        list_name = '',
        button_name = '',
    }: {
        product_name: string;
        list_name: string;
        button_name: string;
    },
) => {
    if (!url) return {};
    if (url?.includes?.(`${locale}.ecoflow.com/cart/`) || url?.includes?.(`${locale}.ecoflow.com/checkouts/`)) {
        // 以 https://${locale}.ecoflow.com/[checkouts, cart]/  开头使用埋点【34】， checkout事件
        return {
            event: 'uaEvent',
            event_name: 'checkout',
            button_name: `${button_name}_${product_name}`,
        };
    } else if (url?.includes?.(`${locale}.ecoflow.com/`)) {
        // 以 https://${locale}.ecoflow.com/ 开头的URL， 且不是结账页 （含产品详情页和其他页）使用埋点【33】，buy事件
        return {
            event: 'uaEvent',
            event_name: 'buy',
            product_name,
            url,
        };
    } else if (url?.includes?.('www.ecoflow.com')) {
        // 以 www.ecoflow.com/${locale}/ 开头的URL （含产品详情页和其他页）使用埋点 【52】，select_product 事件
        return {
            event: 'uaEvent',
            event_name: 'select_product',
            list_name,
            product_name,
            button_name,
        };
    } else {
        // 以上类型之外 使用埋点【64】， view_more事件
        return {
            event: 'uaEvent',
            event_name: 'view_more',
            list_name,
            button_name,
        };
    }
};
